export const dimens = {
  SPACING_NONE: '0rem',
  SPACING_XXXXS: '0.063rem', //1px
  SPACING_XXXS: '0.125rem', //2px
  SPACING_XXS: '0.25rem', //4px
  SPACING_XXS_NUDGE: '0.375rem', //6px
  SPACING_XS: '0.5rem', //8px
  SPACING_XS_NUDGE: '0.625rem', //10px
  SPACING_S: '0.75rem', //12px
  SPACING_M: '1rem', //16px
  SPACING_L: '1.25rem', //20px
  SPACING_XL: '1.5rem', //24px
  SPACING_XXL: '1.75rem', //28px
  SPACING_XXXL: '2rem', //32px
  SPACING_XXXXL: '2.25rem', //36px
  SPACING_XXXXXL: '2.5rem', //40px
  SPACING_XXXXXXL: '2.75rem', //44px
  SPACING_XXXXXXXL: '3rem', //48px
  SPACING_XXXXXXXXL: '4rem', //64px

  BORDER_WIDTH_NONE: '0rem',
  BORDER_WIDTH_THIN: '0.063rem', //1px
  BORDER_WIDTH_THICK: '0.125rem', //2px
  BORDER_WIDTH_THICKER: '0.25rem', //4px

  BORDER_RADIUS_NONE: '0rem',
  BORDER_RADIUS_2: '0.125rem', //2px
  BORDER_RADIUS_4: '0.25rem', //4px
  BORDER_RADIUS_8: '0.5rem', //8px
  BORDER_RADIUS_10: '0.625rem', //10px
  BORDER_RADIUS_12: '0.75rem', //12px
  BORDER_RADIUS_16: '1rem', //16px
  BORDER_RADIUS_20: '1.25rem', //20px
  BORDER_RADIUS_32: '2rem', //32px
  BORDER_RADIUS_CIRCULAR: '6.25rem', //100px
  BORDER_RADIUS_CIRCLE: '50%',

  LINE_HEIGHT_MEDIUM: '1.375rem', //22px
  LINE_HEIGHT_NORMAL: '1.625rem', //26px
  LINE_HEIGHT_LARGE: '1.75rem', //28px

  PAGE_TITLE_HEIGHT: '3.875rem',

  HEIGHT_SMALL: '2.75rem', //44PX
  HEIGHT_MEDIUM: '3rem', //48px
  PRINT_WIDTH: '16.25rem', //260px

  AVATAR_SIZE: '1.938rem', //79px
  AVATAR_SIZE_LARGE: '4.938rem', //79px
  ICON_XS_SIZE: '1.2rem',
  ICON_SIZE: '1.5rem',
  ICON_SMAL_SIZE: '1.75rem',
  ICON_NORMAL_HEIGHT: '4.875rem', //78px
  LICENSE_PLATE_HIEGHT: '1.5rem',

  MODAL_ZINDEX: 99999,

  FOOTER_HEIGHT: '8.75rem',
  DRAWER_BOTTOM_HEIGHT: '9.375rem',
  CARD_NORMAL_WIDTH: '',
  WEB_VIEW_FOOTER_HEIGHT: '7.063rem',
  WEB_VIEW_HEADER_HEIGHT: '4.625rem',

  BUTTON_EXTRA_SMALL_HEIGHT: '1.5rem', //24px
  BUTTON_SMALL_HEIGHT: '1.875rem', //30px
  BUTTON_MEDIUM_HEIGHT: '2.5rem', //40px
  BUTTON_LARGE_HEGHIT: '3rem', //48px
  BUTTON_SMALL_WIDTH: '5.625rem', //90px

  OPACITY_DISABLE: 0.6,

  // BORDER_RADIUS: '10px',
  // BORDER_RADIUS_ULTRA_EXTRA_SMALL: '0.313rem', //5px
  // BORDER_RADIUS_SMALL: '0.625rem', //10px
  // BORDER_RADIUS_MEDIUM: '0.75rem',
  // BORDER_NORMAL: '1rem', //16px
  // CAR_BUTTON_BORDER_RADIUS: '1.125rem', //18px

  // PADDING_ULTRA_EXTRA_SMALL: '0.375rem', //6px
  // PADDING_EXTRA_SMALL: '0.5rem', //8px
  // PADDING_SMALL: '0.75rem', //12px
  // PADDING_NORMAL: '1rem', //16px
  // PADDING: '1.125rem', //18px
  // PADDING_MEDIUM: '1.5rem', //24px
  // PADDING_LARGE: '1.875rem', //30px
  // PADDING_EXTRA_LARGE: '2.5rem', //40px
  // PADDING_ULTRA_EXTRA_LARGE: '3.125rem', //50px
  // ERROR_CIRCLE_PADDING: '0.3315rem',

  // MARGIN_VERY_SMALL: '0.2rem',
  // MARGIN_ULTRA_EXTRA_SMALL: '0.313rem', //5px
  // MARGIN_EXTRA_SMALL: '0.5rem', //8px
  // MARGIN_SMALL: '0.75rem', //12px
  // MARGIN_NORMAL: '1rem', //16px
  // MARGIN: '1.125rem', //18px
  // MARGIN_MEDIUM: '1.5rem', //24px
  // MARGIN_LARGE: '1.875rem', //30px
  // MARGIN_EXTRA_LARGE: '2.5rem', //40px
  // MARGIN_ULTRA_EXTRA_LARGE: '3.125rem', //50px
  // LAYOUT_MARGIN: '1.875rem',
  // EMPTY_SECTION_LAYOUT_MARGIN: '8rem',
  // CAR_INFORMATION_HEADER_MARGIN_BOTTOM: '1.75rem',
  // CAR_INFORMATION_HEADER_RIGHT_ICON_MARGIN: '0.625rem',

  // BORDER_WIDTH: '1px',
  // BORDER_WIDTH_MEDIUM: '2px',
}